import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import PeopleIcon from "@mui/icons-material/People";
import LoginIcon from "@mui/icons-material/Login";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import QuizIcon from "@mui/icons-material/Quiz";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { Link, useNavigate } from "react-router-dom";
import AppContext from "../../../AppContext";
import { fbLogout } from "../../../db/firebaseMethods";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import "./appBar.css";

export default function ButtonAppBar() {
  const { user } = React.useContext(AppContext);
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    fbLogout();
    navigate("/");
  };

  const toggleDrawer = (open) => () => setDrawerOpen(open);

  const navLinkSx = {
    color: "#fff",
    fontWeight: 600,
    fontSize: "0.88rem",
    textTransform: "none",
    letterSpacing: "0.3px",
    borderRadius: "8px",
    px: 1.5,
    "&:hover": { color: "#fff", background: "rgba(255,255,255,0.12)" },
  };

  const primaryBtnSx = {
    background: "linear-gradient(135deg, #ec398b 0%, #8b31c7 100%)",
    color: "#fff",
    fontWeight: 700,
    fontSize: "0.85rem",
    textTransform: "none",
    borderRadius: "20px",
    px: 2,
    ml: 1,
    boxShadow: "0 2px 10px rgba(236,57,139,0.35)",
    "&:hover": {
      background: "linear-gradient(135deg, #d42d7a 0%, #7a2ab3 100%)",
      boxShadow: "0 4px 16px rgba(236,57,139,0.5)",
      transform: "translateY(-1px)",
    },
    transition: "all 0.2s ease",
  };

  const drawerContent = (
    <Box
      sx={{ width: 260, pt: 1 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <Box sx={{ px: 2, py: 1.5, borderBottom: "1px solid #eee" }}>
        <Box sx={{ fontWeight: 700, fontSize: "0.85rem", color: "#302b63", letterSpacing: 1 }}>
          XII. ZEKA VE YETENEK KONGRESİ
        </Box>
      </Box>
      <List dense>
        {!user && (
          <>
            <ListItem button component={Link} to="/login">
              <ListItemIcon><LoginIcon fontSize="small" sx={{ color: "#302b63" }} /></ListItemIcon>
              <ListItemText primary="Giriş Yap" />
            </ListItem>
            <ListItem button component={Link} to="/signup">
              <ListItemIcon><PersonAddIcon fontSize="small" sx={{ color: "#ec398b" }} /></ListItemIcon>
              <ListItemText primary="Kayıt Ol" />
            </ListItem>
          </>
        )}
        {user && (
          <>
            <ListItem button component={Link} to="/profile">
              <ListItemIcon><PersonIcon fontSize="small" sx={{ color: "#302b63" }} /></ListItemIcon>
              <ListItemText primary="Profilim" />
            </ListItem>
            <ListItem button component={Link} to="/bulk-payment">
              <ListItemIcon><PeopleIcon fontSize="small" sx={{ color: "#302b63" }} /></ListItemIcon>
              <ListItemText primary="Toplu Ödeme" />
            </ListItem>
            {["admin", "developer"].includes(user.role) && (
              <ListItem button component={Link} to="/admin">
                <ListItemIcon><AdminPanelSettingsIcon fontSize="small" sx={{ color: "#ec398b" }} /></ListItemIcon>
                <ListItemText primary="Yönetim Paneli" />
              </ListItem>
            )}
          </>
        )}
        <Divider sx={{ my: 0.5 }} />
        <ListItem button component={Link} to="/sss">
          <ListItemIcon><QuizIcon fontSize="small" sx={{ color: "#302b63" }} /></ListItemIcon>
          <ListItemText primary="Sıkça Sorulan Sorular" />
        </ListItem>
        {user && (
          <ListItem button onClick={handleLogout}>
            <ListItemIcon><LogoutIcon fontSize="small" sx={{ color: "#888" }} /></ListItemIcon>
            <ListItemText primary="Çıkış Yap" primaryTypographyProps={{ color: "#888" }} />
          </ListItem>
        )}
      </List>
    </Box>
  );

  return (
    <Box sx={{ flexGrow: 1, mb: 1 }}>
      <Box
        sx={{
          background: "rgba(255,255,255,0.09)",
          backdropFilter: "blur(14px)",
          WebkitBackdropFilter: "blur(14px)",
          border: "1px solid rgba(255,255,255,0.13)",
          borderRadius: "14px",
          boxShadow: "0 2px 16px rgba(0,0,0,0.22)",
          px: 2,
          py: 0.5,
          display: "flex",
          alignItems: "center",
          minHeight: 52,
        }}
      >
        {/* Mobil hamburger */}
        <IconButton
          size="medium"
          onClick={toggleDrawer(true)}
          sx={{ display: { xs: "flex", md: "none" }, color: "#fff", mr: 1 }}
        >
          <MenuIcon />
        </IconButton>

        {/* Başlık */}
        <Box
          sx={{
            fontWeight: 800,
            fontSize: { xs: "0.78rem", md: "0.92rem" },
            color: "#fff",
            letterSpacing: "0.5px",
            flexGrow: 1,
            textAlign: "left",
            display: { xs: "none", sm: "block" },
          }}
        >
          XII. ZEKA VE YETENEK KONGRESİ
        </Box>

        {/* Desktop nav */}
        <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center", gap: 0.5 }}>
          <Button component={Link} to="/sss" sx={navLinkSx} startIcon={<QuizIcon sx={{ fontSize: 16 }} />}>
            Sıkça Sorulan Sorular
          </Button>

          {!user && (
            <>
              <Button component={Link} to="/login" sx={navLinkSx} startIcon={<LoginIcon sx={{ fontSize: 16 }} />}>
                Giriş Yap
              </Button>
              <Button component={Link} to="/signup" sx={primaryBtnSx} startIcon={<PersonAddIcon sx={{ fontSize: 16 }} />}>
                Kayıt Ol
              </Button>
            </>
          )}

          {user && (
            <>
              <Button component={Link} to="/profile" sx={navLinkSx} startIcon={<PersonIcon sx={{ fontSize: 16 }} />}>
                Profilim
              </Button>
              <Button
                component={Link}
                to="/bulk-payment"
                sx={{ ...navLinkSx, border: "1px solid rgba(255,255,255,0.25)" }}
                startIcon={<PeopleIcon sx={{ fontSize: 16 }} />}
              >
                Toplu Ödeme
              </Button>
              {["admin", "developer"].includes(user.role) && (
                <Button component={Link} to="/admin" sx={primaryBtnSx} startIcon={<AdminPanelSettingsIcon sx={{ fontSize: 16 }} />}>
                  Yönetim
                </Button>
              )}
              <Button
                onClick={handleLogout}
                sx={{ ...navLinkSx, color: "#fff", ml: 0.5 }}
                startIcon={<LogoutIcon sx={{ fontSize: 16 }} />}
              >
                Çıkış
              </Button>
            </>
          )}
        </Box>
      </Box>

      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        {drawerContent}
      </Drawer>
    </Box>
  );
}
